/*
    Configuración: History
    Descripción: Establecer un entorno para la navegación entre las distintas rutas de la aplicación
*/
import * as history from 'history';

export default history.createBrowserHistory();